import { Link } from "react-router-dom";

const HavnsLogo = ({ className = "", linkTo = "/" }) => {
  return (
    <Link to={linkTo} className={`inline-flex items-baseline no-underline ${className}`}>
      {/* H with dot - Hinge style */}
      <span className="relative" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, color: '#1A1A1A' }}>
        <span className="relative">
          H
          <span 
            className="absolute bg-[#1A1A1A] rounded-full"
            style={{
              width: '0.2em',
              height: '0.2em',
              top: '-0.08em',
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          />
        </span>
      </span>
      {/* avns - lighter weight for contrast */}
      <span 
        style={{ 
          fontFamily: "'DM Sans', sans-serif",
          fontWeight: 400,
          color: '#1A1A1A',
          letterSpacing: '-0.01em'
        }}
      >
        avns
      </span>
    </Link>
  );
};

export default HavnsLogo;
